import type { FC } from "react";
import type { ComponentEmptyStateComponent } from "@motain/xpa-proto-files-web/lib/types/component_empty_state";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import styles from "./MatchLineupEmptyState.module.scss";
import classNames from "classnames";
import { isNonNullable } from "@/types/isNonNullable";
export const MatchLineupEmptyState: FC<ComponentEmptyStateComponent> = (
  props,
) => {
  const { imageObject, message } = props;

  return (
    <section className={styles.container}>
      {isNonNullable(imageObject) && (
        <ImageWithFallback
          width={180}
          height={180}
          alt={imageObject.alt}
          src={imageObject.path}
          darkModeSrc={imageObject.darkModePath}
          fallbackImage={
            "https://images.onefootball.com/cw/icons/info-light.svg"
          }
          fallbackImageSrcDark={
            "https://images.onefootball.com/cw/icons/info-dark.svg"
          }
          className={styles.image}
        ></ImageWithFallback>
      )}

      <p className={classNames("title-7-regular", styles.message)}>{message}</p>
    </section>
  );
};
